import { render, staticRenderFns } from "./navItem.vue?vue&type=template&id=16194e2e"
import script from "./navItem.vue?vue&type=script&lang=js"
export * from "./navItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports